import axios from "axios";
import { App_Url_New } from "../common/static";
import { UploadOcrDocumentParams } from "../types";

const ocrClient = axios.create({
  baseURL: import.meta.env.VITE_APP_ENDPOINT_URL,
});

export async function uploadOcrDocument({
  endpointPath = App_Url_New.ApiOcrEndPoint.ExtractDocument,
  fields = {},
  files = [],
  headers = {},
}: UploadOcrDocumentParams) {
  const formData = new FormData();

  Object.entries(fields).forEach(([key, value]) => {
    if (value !== null && value !== undefined) {
      formData.append(key, String(value));
    }
  });

  files.forEach(({ name, file }) => {
    if (file) {
      formData.append(name, file);
    }
  });
  // console.log("OCR:", ocrClient, endpointPath, formData);

  const response = await ocrClient.post(endpointPath, formData, {
    headers: {
      "x-client-id": "nexsys_rd",
      "x-api-key": "NezaSyD1IRFXeEs9RsybLl184QeNat3vDO_jm3g_Nexsys",
      "Content-Type": "multipart/form-data",
      ...headers,
    },
  });

  return response.data;
}
